'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (state) {
  return _extends({}, state, {
    pageName: 'home page'
  });
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-analytics/build/reducers/home.js
 ** module id = 442
 ** module chunks = 0
 **/